module.exports = __webpack_public_path__ + "media/src/images/zu_05keep_rules06-a03d7e6f2bde16a5a1c4ea5afecdf765.png";